import React, { useState, useRef, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { ADAARIARoles } from '../../../../models/ADA';
import { getNavbarHeight, getViewportDimensions } from '../../../../models/Utils';

import './IntroBars.scss';
import { LearnMoreButton } from '../LearnMore/LearnMoreButton';

const mobileScreenThreshold = 767; // MUST BE IN SYNC WITH CSS
const bottomMarginOnMobile = 30; // MUST BE IN SYNC WITH CSS

const IntroBars = React.forwardRef((props, theRef) => {
  const [ heightParams, setHeightParams ] = useState({ marginTop: 0, height: 0 });
  const mobileMinHeight = 40 + 2 * 32 + 40; // padding-top + 2 * title_height + padding-bottom from CSS
  const [ mobileMaxHeight, setMobileMaxHeight ] = useState(0);
  const refMobileMaxHeight = useRef(mobileMaxHeight); // 40vh from CSS
  const mobileSpaceBetween = 10; // margin-top from CSS
  const [ isMobileLayout, setIsMobileLayout ] = useState(false);
  const refIsMobileLayout = useRef(isMobileLayout);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const container = useRef(null);
  const content = useRef(null);
  const boxesHolder = useRef(null);
  const barsContainer = useRef(null);
  const [activeColumn, setActiveColumn] = useState(-1);
  const columns = props.data.Boxes.map(box => ({
    title: box.Header,
    text: box.Body,
    learnMore: box.LearnMore
  }));
  const columnRefs = columns.map((column) => useRef(null));
  const columnBodyTextRefs = columns.map((column) => useRef(null));

  const [ animationState, setAnimationState ] = useState({
    bgndColor: 'black',
    titleClass: 'white',
    subtitleClass: 'invisible',
    boxesClass: 'invisible',
    barsClass: 'visible',
    blockerClass: 'visible',
    mobileBoxesClass: '',
    scrollProtectorClass: '',
  });

  const getBoxes = (mobileClass) => {
    let items = [];
    columns.forEach((column, i) => {
      items.push(
        <div className="cpvi-grid-col w4" key={i}>
          <div className={`vbn-ib-box-wrapper ${mobileClass}`}>
            <div 
              className={`vbn-ib-box ${mobileClass} ${activeColumn === -1 ? '' : (activeColumn === i || activeColumn === 10 ? 'active' : '')}`}
              ref={columnRefs[i]}
              onMouseEnter={() => handleColumnMouseEnter(i)}
              onMouseLeave={() => handleColumnMouseLeave()}
              onFocus={() => handleColumnMouseEnter(i)}
              onBlur={() => handleColumnMouseLeave()}
              tabIndex="-1"
              //aria-label={`Box ${i+1}`}
              //role={ADAARIARoles.Group}
            >
              {/*<div className="vbn-ib-column--bgnd-wrapper">
                <div
                  className="vbn-ib-column--bgnd"
                  style={{
                    backgroundImage: `url("${column.image}")`,
                    height: isMobileLayout ? `${mobileMaxHeight}px` : ''
                  }}
                  role="img"
                  alt={column.image.AltText}
                >
                  <div className="vbn-ib-column--bgnd-overlay" style={{ opacity: column.bgndOpacity || 0, backgroundColor: column.bgndOverlayColor || null }}></div>
                </div>
              </div>
              <div className="vbn-ib-column--text-wrapper">
                <div className="vbn-ib-column--title" role={ADAARIARoles.Heading}>{keepSpaceTogether(column.title, togetherString)}</div>
                <div className="ada-hidden">:</div>
                <div className="vbn-ib-column--text" ref={columnBodyTextRefs[i]}>
                  <div className="vbn-ib-column--text-inner">{keepSpaceTogether(column.text, togetherString)}</div>
                </div>
              </div>*/}
              <div>
                <div className="vbn-ib-box--title" role={ADAARIARoles.Heading}>{column.title}</div>
                <div className="vbn-ib-box--text" ref={columnBodyTextRefs[i]}>
                  <div className="vbn-ib-box--text-inner">{column.text}</div>
                </div>
              </div>
              <LearnMoreButton
                data={column.learnMore}
                className='vbn-ib-box--learn-more'
              />
            </div>
          </div>
        </div>
      );
    });
    return items;
  };

  const getBars = () => {
    let items = [];
    for (let i = 0; i < 12; i++) {
      items.push(
        <div className="cpvi-grid-col w1" key={i}>
          <div className="vbn-ib-bar-wrapper">
            <div className={`vbn-ib-bar-inner anim-${i*7%5+1}`}></div>
          </div>
        </div>
      );
    }
    return items;
  };

  const expandBoxesOnMobile = () => {
    setActiveColumn(10);
    for (let column = 0; column < 3; column++) {
      const columnElement = columnBodyTextRefs[column].current;
      const innerTextHeight = columnElement.getElementsByClassName('vbn-ib-box--text-inner')[0].getBoundingClientRect().height;
      columnElement.style.height = `${innerTextHeight}px`;
    }
  };

  const handleColumnMouseEnter = (column) => {
    setActiveColumn(column);
    const columnElement = columnBodyTextRefs[column].current;
    const innerTextHeight = columnElement.getElementsByClassName('vbn-ib-box--text-inner')[0].getBoundingClientRect().height;
    columnElement.style.height = `${innerTextHeight}px`;
  };

  const handleColumnMouseLeave = () => {
    setActiveColumn(-1);
    columnBodyTextRefs.forEach((ref, i) => {
      ref.current.style.height = '0px';
    });
  };

  const handleResize = () => {
    const marginTop = getNavbarHeight();
    const viewport = getViewportDimensions();
    const contentHeight = content.current.getBoundingClientRect().height;
    const height = viewport.height - marginTop;
    const onMobile = viewport.width <= mobileScreenThreshold;
    setIsMobileLayout(onMobile);
    refIsMobileLayout.current = onMobile;
    const shiftTop = onMobile ? 0 : Math.min(marginTop, (height - contentHeight) / 2);
    setHeightParams({
      marginTop: marginTop - shiftTop,
      height: height + shiftTop,
    });
    if (!onMobile) {
      // columnRefs.forEach((columnRef, i) => {
      //   columnRef.current.style.height = '';
      //   columnBodyTextRefs[i].current.style.opacity = '';
      // });
    } else {
      // const maxH = getViewportDimensions().height * 0.4;
      // setMobileMaxHeight(maxH);
      // refMobileMaxHeight.current = maxH;
    }
  };

  const performAnimation = () => {
    let timeout = refIsMobileLayout.current ? 100 : 0;
    let mobileClass = '';

    // Put the boxes in the right place on screen for mobile
    if (refIsMobileLayout.current) {
      setTimeout(() => {
        const firstBoxRect = columnRefs[0].current.getBoundingClientRect();
        const viewport = getViewportDimensions();
        const offset = viewport.height - (firstBoxRect.y + firstBoxRect.height) - bottomMarginOnMobile;
        window.boxRef = columnRefs[0].current;
        barsContainer.current.style.top = `${offset}px`;
        boxesHolder.current.style.top = `${offset}px`;
      }, timeout);
      timeout += 10;
    }

    // Bars dance
    setTimeout(() => {
      setAnimationState({
        bgndColor: 'black',
        titleClass: 'white',
        subtitleClass: 'invisible',
        boxesClass: 'invisible',
        barsClass: 'visible',
        blockerClass: 'visible',
        mobileBoxesClass: mobileClass,
        scrollProtectorClass: '',
      });
    }, timeout);

    // Color transition
    timeout += 1510;
    setTimeout(() => {
      setAnimationState({
        bgndColor: 'white',
        titleClass: 'black',
        subtitleClass: refIsMobileLayout.current ? 'invisible' : 'visible',
        boxesClass: 'visible',
        barsClass: 'invisible',
        blockerClass: 'visible',
        mobileBoxesClass: mobileClass,
        scrollProtectorClass: '',
      });
    }, timeout);

    // Hide bars completely
    timeout += 550;
    setTimeout(() => {
      setAnimationState({
        bgndColor: 'white',
        titleClass: 'black',
        subtitleClass: refIsMobileLayout.current ? 'invisible' : 'visible',
        boxesClass: 'visible',
        barsClass: 'invisible unclickable',
        blockerClass: 'visible',
        mobileBoxesClass: mobileClass,
        scrollProtectorClass: '',
      });
    }, timeout);
    
    // Positions change on mobile
    if (refIsMobileLayout.current) {
      timeout += 200;
      mobileClass = 'final-on-mobile';
      setTimeout(() => {
        setAnimationState({
          bgndColor: 'white',
          titleClass: 'black',
          subtitleClass: 'invisible',
          boxesClass: 'visible',
          barsClass: 'invisible',
          blockerClass: 'visible',
          mobileBoxesClass: mobileClass,
          scrollProtectorClass: '',
        });
        expandBoxesOnMobile();
      }, timeout);

      timeout += 200;
      setTimeout(() => {
        barsContainer.current.style.top = `0px`;
        boxesHolder.current.style.top = `0px`;
        columnRefs.forEach((columnRef, i) => {
          const height = columnRef.current.getBoundingClientRect().height;
          columnRef.current.parentNode.style.height = `${height}px`;
        });
      }, timeout);

      timeout += 500;
      setTimeout(() => {
        setAnimationState({
          bgndColor: 'white',
          titleClass: 'black',
          subtitleClass: 'visible',
          boxesClass: 'visible',
          barsClass: 'invisible',
          blockerClass: 'visible',
          mobileBoxesClass: mobileClass,
          scrollProtectorClass: '',
        });
      }, timeout);
    }

    // Hide blocker
    timeout += 50;
    setTimeout(() => {
      setAnimationState({
        bgndColor: 'white',
        titleClass: 'black',
        subtitleClass: 'visible',
        boxesClass: 'visible',
        barsClass: 'invisible unclickable',
        blockerClass: 'invisible',
        mobileBoxesClass: mobileClass,
        scrollProtectorClass: 'invisible',
      });
    }, timeout);
  };

  useLayoutEffect(() => {
    handleResize();
    performAnimation();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="vbn-intro-bars">
      <div style={{ height: `${heightParams.marginTop}px` }}></div>
      <div className="vbn-ib-wrapper" ref={container} style={{ height: `${heightParams.height}px` }}>
        <div className="vbn-ib-bgnd" style={{ backgroundColor: animationState.bgndColor }}></div>
        <div className="vbn-ib-content" ref={content}>
          <div className="vbn-ib-line">
            <div className="cpvi-grid-container">
              <div className="cpvi-grid-row">
                <div className="vbn-ib-text-content cpvi-grid-col w12">
                  <h1 className={`vbn-ib-title ${animationState.titleClass}`}>{props.data.Header}</h1>
                  <div className={`vbn-ib-subtitle cont-75 ${animationState.subtitleClass}`}>
                    <div>{props.data.Body}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vbn-ib-line">
            <div className="cpvi-grid-container">
              <div className={`vbn-ib-boxes-holder ${animationState.mobileBoxesClass} cpvi-grid-row ${animationState.boxesClass}`} ref={boxesHolder}>
                {getBoxes(animationState.mobileBoxesClass)}
              </div>
            </div>
          </div>
          <div className={`vbn-ib-line bottom vbn-ib-bars-holder ${animationState.barsClass}`}>
            <div className="cpvi-grid-container">
              <div className={`vbn-ib-bars-container cpvi-grid-row ${animationState.mobileBoxesClass}`} ref={barsContainer}>
                {getBars()}
              </div>
            </div>
          </div>
        </div>
        <div className={`vbn-ib-blocker ${animationState.blockerClass}`}></div>
      </div>
      <div className={`vbn-ib-scroll-protector ${animationState.scrollProtectorClass}`}></div>
    </div>
  );
});

export default IntroBars;
